import { notification, Space, Card, Col, Row } from 'antd';
import moment from 'moment';

import React, { useEffect, useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  fetchJobAuditDataByJobId,
  GetSessionJobDetails
} from '../../../Apis/Facility';
import { getDataOfPatient } from '../../../Apis/Patient';
import { formatDate } from '../../../Utils/dateFormat';
import CustomAvatar from '../../CustomComponents/CustomAvatar';
// import JobDetails from './JobDetails';
import { AuditInfoContainer } from '../Audit/styledComponents';
import {
  SessionInfoOneContainer,
  DemographicsContainer,
  StyledCard,
  DiagnosisRow,
  DiagnosisCell,
  DiagnosisItem,
  SectionHeader,
  StyledTable,
  DiagnosisTable,
  Value,
  Label,
  PayerGrid,
  PayerItem
} from './styledComponents';

import Spinner from '../../CustomComponents/Spinner';
const SessionDetails = forwardRef((props, ref) => {
  const { jobId } = useParams();
  const [theme] = useSelector(state => [state.themeReducer]);
  // const [loading, setLoading] = useState(false);
  const [scrollLoading, setScrollLoading] = useState(false);

  const userString = localStorage.getItem('user');
  const userType = userString ? JSON.parse(userString) : null;
  const [localDemographicsData, setLocalDemographicsData] = useState([]);
  // const [demographicsData, setDemographicsData] = useState([]);
  const [demographicsData, setDemographicsData] = useState({ result: [] });
  const diagnosisData = props.printMoreData || [];

  const [printInfoData, setPrintInfoData] = useState([]);
  const facilityId = printInfoData?.[0]?.facility?.facilityId;
  const patientId = printInfoData?.[0]?.patientId;
  const [dataMap, setDataMap] = useState({});

  const payerList =
    props.coverages?.[0]?.payers?.map(payer => ({
      name: payer?.payerName || '-',
      type: payer?.payerRank || '-', // e.g., Primary / Secondary
      plan: payer?.issuer?.planNumber || '-' // e.g., 219071093V
    })) || [];
  const allergies = props.allergies?.[0]?.data || [];
  const allergyList = allergies.map(item => ({
    allergen: item.allergen || '-',
    severity: item.severity || '-'
  }));

  const providerData = props.practitioners?.[0]?.data || [];

  const providers = providerData.map(item => ({
    name: `${item.title ? item.title + ' ' : ''}${item.firstName || ''} ${
      item.lastName || ''
    }`.trim(),
    phone: item.officePhone || item.cellPhone || item.homePhone || '-',
    address: [
      item.addressLine1,
      item.addressLine2,
      item.city,
      item.state,
      item.postalCode
    ]
      .filter(Boolean)
      .join(', '),
    upin: item.upin || '-',
    npi: item.npi || '-'
  }));

  const contactData = props.contacts?.[0]?.data || [];

  const contacts = contactData.map(item => ({
    name: `${item.firstName || ''} ${item.lastName || ''}`.trim(),
    types: item.type?.map(t => t.contactType).join(', ') || '-',
    relationship: item.relationship || '-',
    address: [
      item.addressLine1,
      item.addressLine2,
      item.addressLine3,
      item.city,
      item.state,
      item.postalCode
    ]
      .filter(Boolean)
      .join(', '),
    contactInfo:
      item.homePhone || item.cellPhone || item.officePhone || item.email || '-'
  }));

  const fieldKeyMap = {
    'Resident Name': 'lastName',
    'Patient Name': 'patientName', // special case in `getValue`
    'Date of Birth': 'birthDate',
    Gender: 'gender',
    'Admission Date': 'admissionDate',
    'Bed ID': 'bedId',
    'Room Number': 'roomDesc',
    'Facility Name': 'facilityName',
    MRN: 'medicalRecordNumber',
    'Medicare Beneficiary ID': 'medicareBeneficiaryIdentifier',
    'Preferred Name': 'preferredName',
    Unit: 'unitDesc',
    'Room/bed': 'roomDesc',
    'Admission date': 'admissionDate',
    'Init.Adm.Date': 'admissionDate',
    'Orig.Adm.Date': 'admissionDate',
    Birthdate: 'birthDate',
    Age: 'age',
    'Marital status': 'maritalStatus',
    Religion: 'religion',
    Race: 'patientRaces.0.raceDesc',
    Occupation: 'occupation',
    'Legal Mailing address': 'legalMailingAddress',
    'Primary lang': 'languageDesc',
    Medicaid: 'medicaidNumber',
    'Social security': 'socialBeneficiaryIdentifier',
    'Previous Address': 'previousAddress',
    'Previous Phone': 'homePhone'
  };

  const getValue = label => {
    const key = fieldKeyMap[label];
    if (!key) return '-';

    if (label === 'Resident Name') {
      const p = props.patietSection?.[0] || {};
      return `${p?.prefix || ''}. ${p?.lastName || ''} ,${p?.firstName || ''} ${
        p?.middleName ? p.middleName.charAt(0).toUpperCase() + '.' : ''
      }`
        .replace(/\s+/g, ' ')
        .trim();
    }
    if (label === 'Previous Address') {
      const previousAddress = props.patietSection?.[0]?.previousAddress;

      if (!previousAddress) return '-';

      const { addressLine1, addressLine2, addressLine3, city, postalCode } =
        previousAddress;

      // Combine with space only if both are present
      return [addressLine1, addressLine2, addressLine3, postalCode, city]
        .filter(Boolean)
        .join(', ');
    }
    if (label === 'Legal Mailing address') {
      const previousAddress = props.patietSection?.[0]?.previousAddress;
      const legalMailingAddress = props.patietSection?.[0]?.legalMailingAddress;

      if (!legalMailingAddress) return '-';

      // Check if they are the same
      const isSameAsPrevious =
        previousAddress &&
        Object.keys(legalMailingAddress).every(
          key =>
            (previousAddress[key] || '') === (legalMailingAddress[key] || '')
        );

      if (isSameAsPrevious) {
        return 'Same as Previous Address';
      }

      const { addressLine1, addressLine2, addressLine3, postalCode, city } =
        legalMailingAddress;

      return [addressLine1, addressLine2, addressLine3, postalCode, city]
        .filter(Boolean)
        .join(', ');
    }
    if (label === 'Age') {
      const birthDate = props.patietSection?.[0]?.birthDate;
      if (!birthDate) return '-';

      const birth = new Date(birthDate);
      const today = new Date();
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birth.getDate())
      ) {
        age--;
      }
      return `${age} years`;
    }

    const value = props.patietSection?.[0]?.[key];
    if (value && (key === 'birthDate' || key === 'admissionDate')) {
      return formatDate(value, '-');
    }
    return value || '-';
  };

  useEffect(() => {
    if (props.patietSection) {
    }
  }, [props.patietSection]);

  function processValue(value) {
    return value
      .replace(/<p>/g, '')
      .replace(/<\/p>/g, '')
      .replace(/<\/?(ol|ul|li)>/g, '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/(\r\n|\r|\n)/g, '\n');
    // .replace(/\n\s*\d+\.\s*/g, '\n'); // Remove numbered list formatting;`
    // .replace(/<(?!\/?(b|i|s|u)\b)[^>]*>/g, '');
  }

  const getPageMargins = () => {
    return `
 @media print {
      @page {
        margin: .06cm .06cm;
      }

      body {
        counter-reset: page;
      }

      .page::after {
        counter-increment: page;
        content: "Page " counter(page);
        position: fixed;
        bottom: 1cm;
        right: 1.5cm;
        font-size: 12px;
        color: #444;
      }

      .custom-header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        padding-top: 10px;
      }

      .content {
        margin-top: 60px; /* pushes content below fixed header */
      }
    }
    `;
  };

  return (
    // props.printInfoData &&
    // props.printMoreData &&
    <div ref={ref}>
      <style>{getPageMargins()}</style>

      {/* Custom Print Header */}

      {props.loading ? (
        <Spinner height={'50vh'} />
      ) : (
        <>
          <div style={{ padding: 5, fontFamily: 'Arial, sans-serif' }}>
            <h3
              style={{
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                marginBottom: '2px'
              }}
            >
              Admission Record – {props.jobName}
            </h3>
            <SectionHeader>Resident Information</SectionHeader>
            {/* 
            <StyledTable>
              <tbody>
                <tr style={{ backgroundColor: '#f0f0f0' }}>
                  {patientFields.map(label => (
                    <td
                      key={label}
                      style={{ fontWeight: 'bold', textAlign: 'center' }}
                    >
                      {label}
                    </td>
                  ))}
                </tr>
                <tr>
                  {patientFields.map(label => (
                    <td key={label + '-value'} style={{ textAlign: 'center' }}>
                      {getValue(label)}
                    </td>
                  ))}
                </tr>
                <tr>
                  {patientFieldsRow2.map(label => (
                    <td
                      key={label}
                      style={{ fontWeight: 'bold', textAlign: 'center' }}
                    >
                      {label}
                    </td>
                  ))}
                </tr>
                <tr style={{ backgroundColor: '#f0f0f0' }}>
                  {patientFieldsRow2.map(label => (
                    <td key={label + '-value'} style={{ textAlign: 'center' }}>
                      {getValue(label)}
                    </td>
                  ))}
                </tr>
              </tbody>
            </StyledTable>  */}
            <StyledTable>
              <tbody>
                {/* Row 1: Top Headers */}
                {/* <tr
                  style={{ backgroundColor: '#f0f0f0', width: `${100 / 7}%` }}
                >
                  {[
                    'Resident Name',
                    'Preferred Name',
                    'Unit',
                    'Room / Bed',
                    'Admission Date',
                    'Init. Adm. Date',
                    'Orig. Adm. Date'
                  ].map(label => (
                    <td
                      key={label}
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'center',
                        width: `${100 / 7}%`
                      }}
                    >
                      {label}
                    </td>
                  ))}
                </tr> */}

                {/* Row 2: Top Values */}
                {/* <tr>
                  {[
                    getValue('Resident Name'),
                    getValue('Preferred Name'),
                    getValue('Unit'),
                    getValue('Room/bed'),
                    getValue('Admission Date'),
                    getValue('Init.Adm.Date'),
                    getValue('Orig.Adm.Date')
                  ].map((val, i) => (
                    <td
                      key={i}
                      style={{ textAlign: 'center', width: `${100 / 7}%` }}
                    >
                      {val}
                    </td>
                  ))}
                </tr> */}
                <tr style={{ backgroundColor: '#f0f0f0' }}>
                  <td
                    colSpan={2}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Resident Name
                  </td>
                  <td style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    Preferred Name
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Unit
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Room / Bed
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Admission Date
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Init. Adm. Date
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Orig. Adm. Date
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={2}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    {getValue('Resident Name')}
                  </td>
                  <td style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    {getValue('Preferred Name')}
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    {getValue('Unit')}
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    {getValue('Room/bed')}
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    {getValue('Admission Date')}
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    {getValue('Init.Adm.Date')}
                  </td>
                  <td
                    colSpan={1}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    {getValue('Orig.Adm.Date')}
                  </td>
                </tr>

                {/* Row 3: Address Section Header */}
                <tr style={{ backgroundColor: '#f0f0f0' }}>
                  <td
                    colSpan={4}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Previous address
                  </td>
                  <td style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    Previous Phone
                  </td>
                  <td
                    colSpan={3}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Legal Mailing address
                  </td>
                </tr>

                {/* Row 4: Address Section Values */}
                <tr>
                  <td colSpan={4} style={{ textAlign: 'center' }}>
                    {getValue('Previous Address')}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {getValue('Previous Phone')}
                  </td>
                  <td colSpan={3} style={{ textAlign: 'center' }}>
                    {getValue('Legal Mailing address')}
                  </td>
                </tr>

                {/* Row 5: Personal Info Headers */}
                <tr style={{ backgroundColor: '#f0f0f0' }}>
                  {[
                    'Gender',
                    'Birthdate',
                    'Age',
                    'Marital Status',
                    'Religion',
                    'Race',
                    'Occupation(s)',
                    'Primary Lang.'
                  ].map(label => (
                    <td
                      key={label}
                      style={{ fontWeight: 'bold', textAlign: 'center' }}
                    >
                      {label}
                    </td>
                  ))}
                </tr>

                {/* Row 6: Personal Info Values */}
                <tr>
                  {[
                    getValue('Gender'),
                    getValue('Date of Birth'),
                    getValue('Age'),
                    getValue('Marital status'),
                    getValue('Religion'),
                    getValue('Race'),
                    getValue('Occupation'),
                    getValue('Primary lang')
                  ].map((val, i) => (
                    <td key={i} style={{ textAlign: 'center' }}>
                      {val}
                    </td>
                  ))}
                </tr>

                <tr style={{ backgroundColor: '#f0f0f0' }}>
                  <td
                    colSpan={2}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Social Security #
                  </td>
                  <td style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    Medicaid
                  </td>
                  <td
                    colSpan={3}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Medicare Beneficiary ID
                  </td>
                  <td
                    colSpan={2}
                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Patient Type
                  </td>
                </tr>

                {/* Row 4: Address Section Values */}
                <tr>
                  <td colSpan={2} style={{ textAlign: 'center' }}>
                    {getValue('Social security')}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {getValue('Medicaid')}
                  </td>
                  <td colSpan={3} style={{ textAlign: 'center' }}>
                    {getValue('Medicare Beneficiary ID')}
                  </td>
                  <td colSpan={2} style={{ textAlign: 'center' }}>
                    {
                      props.printInfoData?.[0]?.patientAssignmentData
                        ?.patientTermType
                    }
                  </td>
                </tr>
              </tbody>
            </StyledTable>

            <SectionHeader>Payer Information</SectionHeader>
            <StyledTable>
              <tbody>
                {props.coverages?.[0]?.payers?.length > 0 ? (
                  props.coverages[0].payers.map((payer, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td colSpan={1}>
                          <strong>Payer Name:</strong>{' '}
                          {payer.payerName || '-'}
                        </td>
                        <td colSpan={1}>
                          <strong>Payer Rank:</strong>{' '}
                          {payer.payerRank || '-'}
                        </td>
                        <td colSpan={1}>
                          <strong>Account Description:</strong>{' '}
                          {payer.accountDescription || '-'}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={1}>
                          <strong>Account Number:</strong>{' '}
                          {payer.accountNumber || '-'}
                        </td>
                        <td colSpan={1}>
                          <strong>Issuer Name:</strong>{' '}
                          {payer.issuer?.issuerName || '-'}
                        </td>
                        <td colSpan={1}>
                          <strong>Plan Number:</strong>{' '}
                          {payer.issuer?.planNumber || '-'}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3}>
                          <strong>Plan Effective Date:</strong>{' '}
                          {formatDate(payer.issuer?.planEffectiveDate, '-')}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3}>-</td>
                  </tr>
                )}
              </tbody>
            </StyledTable>

            <SectionHeader>Other Information (Allergies)</SectionHeader>
            <StyledTable>
              <thead>
                <tr>
                  <th>Allergen</th>
                  <th>Severity</th>
                </tr>
              </thead>
              <tbody>
                {allergyList.map((a, i) => (
                  <tr key={i}>
                    <td>{a.allergen}</td>
                    <td>{a.severity}</td>
                    {/* <td>{a.type}</td> */}
                  </tr>
                ))}
              </tbody>
            </StyledTable>

            <SectionHeader>Care Providers</SectionHeader>
            <StyledTable>
              <thead>
                <tr>
                  <th>Provider</th>
                  <th>Phone</th>
                  <th>Address</th>
                  <th>UPIN</th>
                  <th>NPI</th>
                </tr>
              </thead>
              <tbody>
                {providers.map((p, i) => (
                  <tr key={i}>
                    <td>{p.name}</td>
                    <td>{p.phone}</td>
                    <td>{p.address}</td>
                    <td>{p.upin}</td>
                    <td>{p.npi}</td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>

            <SectionHeader>Contacts</SectionHeader>
            <StyledTable>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Relationship</th>
                  <th>Address</th>
                  <th>Phone/Email</th>
                </tr>
              </thead>
              <tbody>
                {contacts.map((c, i) => (
                  <tr key={i}>
                    <td>{c.name}</td>
                    <td>{c.types}</td>
                    <td>{c.relationship}</td>
                    <td>{c.address}</td>
                    <td>{c.contactInfo}</td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>

            {props.cptCodesInContent?.length > 0 && (
              <>
                <SectionHeader>CPT Codes</SectionHeader>
                <StyledTable>
                  <tbody>
                    <tr>
                      <td>
                        {props.cptCodesInContent.map(c => c.cptCode).filter(Boolean).join(', ')}
                      </td>
                    </tr>
                  </tbody>
                </StyledTable>
              </>
            )}

            <SectionHeader>Diagnosis Information</SectionHeader>

            <DiagnosisTable>
              {Array.from(
                { length: Math.ceil(diagnosisData.length / 2) },
                (_, rowIndex) => {
                  const left = diagnosisData[rowIndex * 2];
                  const right = diagnosisData[rowIndex * 2 + 1];

                  return (
                    <DiagnosisRow key={rowIndex}>
                      <DiagnosisCell>
                        {left ? (
                          <DiagnosisItem>
                            <strong>
                              {left.onsetDate
                                ? formatDate(left.onsetDate, '-')
                                : '-'}
                            </strong>{' '}
                            {left.icd10Description
                              ? `${left.icd10Description.slice(0, 32)}${
                                  left.icd10Description.length > 32 ? '...' : ''
                                }`
                              : '-'}
                            {left.icd10 && ` (${left.icd10})`}
                          </DiagnosisItem>
                        ) : null}
                      </DiagnosisCell>
                      <DiagnosisCell>
                        {right ? (
                          <DiagnosisItem>
                            <strong>
                              {right.onsetDate
                                ? formatDate(right.onsetDate, '-')
                                : '-'}
                            </strong>{' '}
                            {left.icd10Description
                              ? `${left.icd10Description.slice(0, 32)}${
                                  left.icd10Description.length > 32 ? '...' : ''
                                }`
                              : '-'}
                            {left.icd10 && ` (${left.icd10})`}
                          </DiagnosisItem>
                        ) : null}
                      </DiagnosisCell>
                    </DiagnosisRow>
                  );
                }
              )}
            </DiagnosisTable>
          </div>
        </>
      )}
    </div>
  );
});

export default SessionDetails;
